export const stringOrVoid = (condition: boolean, stringValue: string) =>
  condition ? stringValue : undefined;
